import { render, staticRenderFns } from "./cameraPermission.vue?vue&type=template&id=749bcb60"
import script from "./cameraPermission.vue?vue&type=script&lang=js"
export * from "./cameraPermission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports